module.exports = __webpack_public_path__ + "img/detail_banner_hlwyy.fab27dba.png";